import { render, staticRenderFns } from "./180.vue?vue&type=template&id=74a4934c&scoped=true&"
var script = {}
import style0 from "./180.vue?vue&type=style&index=0&id=74a4934c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4934c",
  null
  
)

export default component.exports